export enum BudgetSummaryBarViewMode {
  Expenses = 'expenses',
  Invoices = 'invoices',
  PlanDetails = 'planDetails', // can be changed (not used yet)
  ManageTable = 'manageTable' // can be changed (not used yet)
}
